import type { CaseStatus } from "../api/types.ts"

export type StepState = "done" | "current" | "todo"
export type CaseStep = { id: string; state: StepState }

/** 서버 상태 머신(server/src/domain/case-status.ts)의 본줄기. 폐기·취소는 여기 없다. */
const FLOW = ["registered", "arrived", "documented", "shipped", "returned"] as const

/** 종료 상태는 본줄기 밖이라 스테퍼 대신 종료 안내를 보여 준다. */
export function isTerminalCase(status: CaseStatus): boolean {
  return status === "discarded" || status === "cancelled"
}

export function caseSteps(status: CaseStatus): CaseStep[] {
  const at = FLOW.indexOf(status as (typeof FLOW)[number])
  const current = at === -1 ? 0 : at
  // 마지막 단계에 닿으면 그 단계도 done — 끝난 건에 "진행 중"이 남아 있으면 안 된다.
  const isLast = current === FLOW.length - 1
  return FLOW.map((id, index) => ({
    id,
    state:
      index < current || (isLast && index === current)
        ? "done"
        : index === current
          ? "current"
          : "todo",
  }))
}
